class Prenota {

    constructor() {
        console.log('prenota js class initialized')
        this.events()
    }

    events() {
        document.addEventListener("DOMContentLoaded", e => this.inizializeObj());
    }

    inizializeObj() {
        const prenota_buttons = document.querySelectorAll('.prenotaButton');

        if (prenota_buttons.length > 0) {
            prenota_buttons.forEach(button => {
                button.addEventListener("click", e => this.buttonPrenotaClickHandler(e)); 
            });
        }

        let formLocanda = document.querySelector('#gform_2');
        let formRistorante = document.querySelector('#gform_4');

        // cambio action del form
        if (formLocanda !== null && formRistorante !== null) {
            formLocanda.action = '/prenota/?t=locanda';
            formRistorante.action = '/prenota/?t=ristorante';
        }

        //console.log(formLocanda, formRistorante);
    }

    buttonPrenotaClickHandler(e) {
        const prenota_buttons = document.querySelectorAll('.prenotaButton');
        const targetButton = e.target.closest('.prenotaButton');
        const divLocanda = document.querySelector('#formLocanda');
        const divRistorante = document.querySelector('#formRistorante');
        const inputHiddenLocanda = document.querySelector('#input_2_3');
        const inputHiddenRistorante = document.querySelector('#input_4_1');

        // url query vars
        let url = new URL(window.location.href);
        let urlParams = new URLSearchParams(url.search);
        let tipologiaPrenotazione;

        prenota_buttons.forEach(button => {
            if (button.classList.contains('active')) {
                button.classList.remove('active')
            }
        });

        targetButton.classList.add('active');

        if (targetButton.classList.contains('prenotaLocanda')) {
            // form locanda
            divLocanda.classList.add('active');
            if (divRistorante.classList.contains('active')) {
                divRistorante.classList.remove('active');
            }
            urlParams.set('t', 'locanda');
            inputHiddenLocanda.value = 'locanda';
            inputHiddenRistorante.value = 'locanda';
        } else {
            // form ristorante
            divRistorante.classList.add('active');
            if (divLocanda.classList.contains('active')) {
                divLocanda.classList.remove('active');
            }
            urlParams.set('t', 'ristorante');
            inputHiddenLocanda.value = 'ristorante';
            inputHiddenRistorante.value = 'ristorante';
        }

        urlParams.toString();
        tipologiaPrenotazione = urlParams.get('t');

        // sostituisco param t nella history del browser 
        window.history.replaceState(null, null, '?t='+tipologiaPrenotazione);

        /* const href = new URL(window.location.search); */
        //console.log(formLocanda, formRistorante);
    }
}

export default Prenota;